import { useEffect, useState } from "react";

const EndOfQuiz = ({ handleCompleteQuiz, isSubmitted, isSubmitting = false }) => {
  return (
    <div className="relative">
      {!isSubmitted ? (
        <div>
          You have successfully finished this quiz! To save the results and see
          how you performed press the SUBMIT ANSWERS button.
        </div>
      ) : (
        <div>The results have been submitted. The results are loading.</div>
      )}
      {!isSubmitted && (
        <button
          type="button"
          onClick={handleCompleteQuiz}
          disabled={isSubmitting}
          className={`mt-2 p-4 w-fit bg-accent shadow-default rounded-lg duration-200 ${
            isSubmitting ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:scale-110"
          }`}
        >
          {isSubmitting ? "SUBMITTING..." : "SUBMIT ANSWERS"}
        </button>
      )}
    </div>
  );
};

export default EndOfQuiz;
